import React, {useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useUser } from "../../utils/userContext";
import useHandleErrors from '../../utils/user.utils';
import { ToastContainer, toast } from "react-toastify";
import useConfiguration from '../../utils/ConfigurationContext';


const AnnouncementForm = () => {
    const { user } = useUser();
    const handleErrors = useHandleErrors();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const config = useConfiguration();
    const token = localStorage.getItem("token");
    const [formData, setFormData] = useState({
        Subject: "",
        EventStartDate: "",
        EventEndDate: "",
        Details: "",
        employeeID: user?.EmployeeId,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleReset = () => {
        setFormData({
            Subject: "",
            EventStartDate: "",
            EventEndDate: "",
            Details: "",
            employeeID: user?.EmployeeId,
        });
    };
    
    const handleCloseModal = () => {
        setShowModal(false);
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        if (!formData.Subject) {
            toast.error("Subject is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.EventStartDate) {
            toast.error("Event StartDate is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.EventEndDate) {
            toast.error("Event EndDate is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.Details) {
            toast.error("Details is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
    
        try {
            const path = "/postAnnouncements";
            const URL = process.env.REACT_APP_BE_URL + path;
    
            const response = await axios.post(
                URL,
                JSON.stringify(formData),  // Convert form data to JSON
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
    
            if (response.status === 200) {
                setShowModal(true);
                setFormData({
                    Subject: "",
                    EventStartDate: "",
                    EventEndDate: "",
                    Details: "",
                });
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };
    


    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Announcements</h3>
                        </div>
                        <div class="col-auto">
                            <Link
                                to={"/home"}
                                data-extra-toggle="tab"
                                data-target="#organisation-pan"
                                class="btn btn-primary mt-lg-0 mt-4"
                            >
                                <i class="ri-message-3-line"></i> Dashboard
                            </Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h5 className="title">
                                        Submit Announcements{" "}
                                    </h5>
                                    <hr />
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-6">
                                                <div className="form-group">
                                                    <label for="Subject" className="required">Subject</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="Subject"
                                                        value={formData.Subject}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group col-md-6">
                                                <label htmlFor="EventStartDate" className="required">
                                                    Event Start Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="EventStartDate"
                                                    value={formData.EventStartDate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="EventEndDate" className="required">
                                                    Event End Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="EventEndDate"
                                                    value={formData.EventEndDate}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div className="form-group col-md-12 col-lg-12">
                                                <label htmlFor="Details" className="required">
                                                    Details
                                                </label>
                                                <textarea
                                                    name="Details"
                                                    className="form-control"
                                                    rows="5"
                                                    value={formData.Details}
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body">
                                    <span>
                                        <i className="ri-megaphone-line"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h4 className="mb-2">Latest Announcements</h4>
                                    <p>Stay updated with the latest birthdays, anniversaries, and important management announcements.</p>

                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-auto text-center">
                                            <Link
                                                to={"/home"}
                                                className="info-icon-box"
                                                title="Announcements"
                                                rel="tooltip"
                                            >
                                                <i className="ri-megaphone-line"></i>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className="row align-items-center border-top mt-3">
                                        <div className="col-12">
                                            <p className="mt-3">
                                                Have an announcement to share? Reach out to us!
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-1">
                                            <i className="ri-mail-send-fill"></i>
                                        </div>
                                        <div className="col">{config?.supportEmail}</div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-1">
                                            <i className="ri-message-3-line"></i>
                                        </div>
                                        <div className="col">Chat with us</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center">
                    <button class="btn btn-light" type="reset" onClick={handleReset}>
                        Reset
                    </button>
                    <button
                        class="btn btn-primary"
                        type="button"
                        data-toggle="modal"
                        data-target="#confirmModal"
                        onClick={handleSubmit}
                    >
                        Submit <i class="ri-checkbox-circle-line"></i>
                    </button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Announcement uploaded successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AnnouncementForm;
